import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Shield } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/#parcours', label: 'Parcours', anchor: true },
    { path: '/#competences', label: 'Compétences', anchor: true },
    { path: '/#processus', label: 'Processus', anchor: true },
    { path: '/#mode-travail', label: 'Mode de travail', anchor: true },
    { path: '/#contact', label: 'Contact', anchor: true }
  ];

  const handleClick = (e, path) => {
    e.preventDefault();
    setIsMenuOpen(false);
    
    if (path.startsWith('/#')) {
      const id = path.substring(2);
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <a href="/" className="logo">
          <Shield size={28} strokeWidth={2.5} />
          <span>Vianney Soulard</span>
        </a>

        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          {navLinks.map((link) => (
            <a
              key={link.path}
              href={link.path}
              className="nav-link"
              onClick={(e) => handleClick(e, link.path)}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <button
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;